<template>
    <div class="van-tree-select" :style="'height:'+ height">
      <div class="van-sidebar van-tree-select__nav">
        <div class="van-sidebar-item van-tree-select__nav-item my-class"
             style="border-bottom: 1px #f7f8fa solid;"
           :class="index==activeIndex?'van-sidebar-item--select':''"
           v-for="(item,index) in items" :key="index" @click="bindChange(index)">
          <div class="van-sidebar-item__text">{{item.科室名称}}</div>
        </div>
      </div>
      <div class="van-tree-select__content">
        <div class="van-ellipsis van-tree-select__item" style="border-bottom: 1px #f7f8fa solid;"
             v-for="(item,index) in items[activeIndex].children" :key="index"  @click="$emit('toRegistration',item)">
          {{item.科室名称}}
          <i class="el-icon-arrow-right van-tree-select__selected" style="font-weight: 700;color: #8a8a8a"></i>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
      data(){
        return{
          activeIndex:0
        }
      },
      props:{
        height:{
          type:String,
          default:'400px'
        },
        items:{
          type: Array
        },
      },
      methods:{
        bindChange(index){
          this.activeIndex = index
        },
      }
    }
</script>

<style scoped>
 @import "../../../static/css/vant.css";
</style>



// WEBPACK FOOTER //
// src/components/common/TreeSelect.vue